import React from "react";
import { useContent } from "./content";
import { useHomeLang } from "./homeLang";
import "./advisorMedia.css";

const PHOTOGRAPHS = {
  "07:45": "scene-0745-v2.jpg",
  "10:20": "scene-1020-v2.jpg",
  "13:05": "scene-1305-v2.jpg",
  "16:40": "scene-1640-v3.jpg",
  "19:30": "scene-1930-v2.jpg",
};

// The words on the advisors' videos: the team's title, and the start of the
// disclaimer running along the bottom of the update.
const WORDS = {
  it: { team: "Il team che ti segue", ticker: "Messaggio a scopo informativo" },
  en: { team: "The team looking after you", ticker: "For information purposes only" },
};

export default function AdvisorVideo({ time }) {
  const { DEMO_TEAM } = useContent();
  const words = WORDS[useHomeLang()];
  const photograph = PHOTOGRAPHS[time];
  if (!photograph) throw new Error(`No advisor photograph for ${time}`);
  const introduction = time === "10:20";
  const team = time === "13:05";
  return (
    <span className={`ns-ph ns-advisor${introduction ? " ns-advisor-identified" : ""}${team ? " ns-advisor-with-team" : ""}`}>
      <img className="ns-advisor-picture" src={`/home/advisors/${photograph}`} alt="" width="1600" height={introduction ? "686" : "900"} loading="lazy" decoding="async" />
      {team && (
        <span className="ns-advisor-team">
          <strong>{words.team}</strong>
          {DEMO_TEAM.map(({ name, role }) => <span key={name}>{name}, {role}</span>)}
        </span>
      )}
      {introduction && (
        <span className="ns-advisor-identity">
          <span>
            <span className="ns-advisor-name">Cristina Pacini</span>
            <span className="ns-advisor-role">Private banker</span>
          </span>
        </span>
      )}
      {time === "07:45" && (
        <span className="ns-advisor-ticker">{words.ticker}</span>
      )}
    </span>
  );
}

export function AdvisorAvatar() {
  return (
    <span className="ns-ph ns-ph-face ns-advisor">
      <img className="ns-advisor-picture" src="/home/advisors/profile-1930-v2.jpg" alt="" width="512" height="512" loading="lazy" decoding="async" />
    </span>
  );
}
